import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import { useThemeContext } from "@circle-react/providers/Theme";

import { t } from "@/i18n-js/instance";
import { ResetButton } from "@/react/pages/BotBuilder/ChatPreview/ResetButton";

interface PreviewPausedIndicatorProps {
  description?: string;
  onRestart: () => void;
}

export const PreviewPausedIndicator = ({
  onRestart,
  description = t("community_inbox.preview_paused_description"),
}: PreviewPausedIndicatorProps) => {
  const { isDarkAppearance } = useThemeContext();

  return (
    <div className="mx-4 rounded-lg bg-[rgba(245,158,11,0.1)] p-4 dark:bg-[rgba(245,158,11,0.20)]">
      <div className="flex flex-col items-center justify-center gap-4">
        <div className="flex flex-col items-center justify-center gap-1">
          <div className="flex items-center gap-2">
            <Icon
              type="16-ai-snooze"
              size={16}
              className="text-[#191b1f] dark:text-white"
            />
            <Typography.LabelSm
              weight="semibold"
              color="text-[#191b1f] dark:text-white"
            >
              {t("community_inbox.preview_paused_by_keywords")}
            </Typography.LabelSm>
          </div>
          <div className="text-center">
            <Typography.BodySm color="text-[#545861] dark:text-gray-300">
              {description}
            </Typography.BodySm>
          </div>
        </div>
        <ResetButton
          onClick={onRestart}
          variant={isDarkAppearance ? "light" : "dark"}
        />
      </div>
    </div>
  );
};
